// Entry files are intended for importing and excuting functions and classes only. They should not contain any logic.
/* eslint-disable */
import index from "../objects/global/index";

index();
